<template>
  <div class="credits-container">
    <!-- Informações dos Créditos -->
    <v-card outlined class="credits-card">
      <v-card-title>
        <app-title>Créditos de I.A.</app-title>
      </v-card-title>

      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="2" class="text-center">
            <v-progress-circular :rotate="-90" :size="150" :width="20" :value="usagePercentage" color="primary"
              class="credits-progress">
              <h2 class="progress-text">{{ usagePercentage }}%</h2>
            </v-progress-circular>
          </v-col>

          <v-col cols="12" md="8">
            <div class="d-flex">
              <div class="credit-item mr-10">
                <h3 class="credit-label">Créditos Mensais
                </h3>
                <h2 class="credit-value">{{ formattedCredits }}</h2>
              </div>

              <div class="credit-item">
                <h3 class="credit-label">Créditos Utilizados</h3>
                <h2 class="credit-value">{{ formattedUsedCredits }}</h2>
              </div>


            </div>
            <br />
            <div>
              Seus créditos são renovados todo inicio de mês.
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


  </div>
</template>

<script>
export default {
  name: 'CreditosIA',

  data() {
    return {
      data: {
        ia_credits: 0,
        ia_used_credits: 0,
      },
    };
  },

  computed: {

    formattedCredits() {
      return this.$format.decimal(this.data.ia_credits, 0);
    },

    formattedUsedCredits() {
      return this.$format.decimal(this.data.ia_used_credits, 0);
    },

    formattedRemainingCredits() {
      const remaining = this.data.ia_credits - this.data.ia_used_credits;
      return this.$format.decimal(remaining, 0);
    },

    usagePercentage() {
      if (this.data.ia_credits === 0) return 0;
      return Math.round((this.data.ia_used_credits * 100) / this.data.ia_credits);
    }
  },

  mounted() {

    this.select();

  },

  methods: {

    select() {
      this.$loading.start();
      this.$http.$get('ai-assistant/usage').then((response) => {
        this.data = response.data;
        this.$loading.finish();
      }).catch((error) => {
        this.$loading.finish();

      });
    }
    // initializeSpeechRecognition() {
    //   const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    //   if (!SpeechRecognition) {
    //     console.warn('SpeechRecognition não é suportado neste navegador.');
    //     return;
    //   }

    //   this.speechRecognition = new SpeechRecognition();
    //   this.speechRecognition.lang = 'pt-BR';
    //   this.speechRecognition.interimResults = true;
    //   this.speechRecognition.continuous = true;

    //   this.speechRecognition.onresult = this.handleSpeechResult;
    //   this.speechRecognition.onerror = this.handleSpeechError;
    //   this.speechRecognition.onend = this.handleSpeechEnd;
    // },

    // handleSpeechResult(event) {
    //   let finalTranscript = '';
    //   let interimTranscript = '';

    //   for (let i = event.resultIndex; i < event.results.length; i++) {
    //     const transcript = event.results[i][0].transcript;

    //     if (event.results[i].isFinal) {
    //       finalTranscript += transcript + ' ';
    //     } else {
    //       interimTranscript += transcript + ' ';
    //     }
    //   }

    //   if (finalTranscript) {
    //     this.finalText += finalTranscript;
    //     this.partialText = '';
    //   }

    //   if (interimTranscript) {
    //     this.partialText = interimTranscript;
    //   }
    // },

    // handleSpeechError(error) {
    //   console.error('Erro no reconhecimento de voz:', error.error);
    // },

    // handleSpeechEnd() {
    //   if (this.isRecording) {
    //     // Reinicia automaticamente para conversas longas
    //     this.speechRecognition.start();
    //   } else {
    //     this.isRecording = false;
    //   }
    // },

    // startRecording() {
    //   if (!this.speechRecognition) {
    //     alert('Reconhecimento de voz não está disponível.');
    //     return;
    //   }

    //   this.isRecording = true;
    //   this.finalText = '';
    //   this.partialText = '';
    //   this.enhancedText = '';
    //   this.speechRecognition.start();
    // },

    // stopRecording() {
    //   this.isRecording = false;
    //   if (this.speechRecognition) {
    //     this.speechRecognition.stop();
    //   }
    //   this.enhanceTextWithAI();
    // },

    // async enhanceTextWithAI() {
    //   if (!this.finalText.trim()) {
    //     return;
    //   }

    //   try {
    //     const payload = {
    //       instructions: 'Esse texto vem do SpeechRecognition, então corrija a gramática, não mude o contexto',
    //       inputText: this.finalText
    //     };

    //     const response = await this.$http.$post('ai-assistant/text-generation', payload);
    //     this.enhancedText = response.text;
    //   } catch (error) {
    //     console.error('Erro ao aprimorar texto com I.A.:', error);
    //   }
    // }
  }
};
</script>
